


















































































import { namespace } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Integration } from '@/views/settings/components/Integration.ts.vue';
import { mapState } from 'vuex';

interface IntegrationConfig {
  applicationId: string,
  directoryId: string,
  clientSecret: string,
  searchQuery: string,
  locations: {
    [propName: string]: string | ""
  }
}

class IntegrationForm {
  config?: IntegrationConfig | any
  integration?: Integration | null = null
  id?: number | null = null

  constructor (o: IntegrationForm) {
    this.config = JSON.parse(o.config as string);
    this.integration = o.integration;
    this.id = o.id;
  }
}


const VisitManagement = namespace('visitManagement');
@Component(
  {
    computed: {
    ...mapState('visitManagement', {
      locations: (state : any) => state.locations,
    })
    },
  }
)
export default class IntegrationItem extends Vue {
  @Prop({ default: () => new IntegrationForm({}) })
  private data!: IntegrationForm;
  private form: IntegrationForm = new IntegrationForm(this.data)
  private locations: any;
  private isCustomised: boolean = true;

  private async submit (rest: boolean) {
    if (rest) {
      const isUpdate = this.data.id;
      const dipsatchUrl = isUpdate ? 'updateIntegration' : 'createIntegration';
      let configLocations = {};
      if (this.isCustomised) {
        configLocations = await this.formatConfigLocations(this.form.config.locations);
      }
      this.form.config.locations = configLocations;

      return await this.$store.dispatch(`visitManagement/${dipsatchUrl}`, {
        ...(isUpdate && {id: this.data.id}),
        integration: this.form.integration,
        config: JSON.stringify(this.form.config)
      })
        .then(result => result)
        .catch(err => {
          console.error(err);
          return false;
        });
    }

    return this.form;
  }

  private validateField(): void {
    this.$validator.validateAll();
  }

  private async getFormContactLocations(): Promise<void> {
    const tempLocations = this.locations.items;
    const formConfigLocatonsKeys = this.form.config.locations && Object.keys(this.form.config.locations);
    let configLocations = {};
    tempLocations.forEach((location: any) => {
      const isLocationInFormConfig = formConfigLocatonsKeys && formConfigLocatonsKeys.find((key: any) => parseInt(key) === location.id);
      if (!isLocationInFormConfig) {
        configLocations = {...configLocations, [location.id]: { value: ""}};
      } else {
        configLocations = {...configLocations, [location.id]: { value: this.form.config.locations[isLocationInFormConfig]}};
      }
    });
    this.form.config.locations = configLocations;
  }

  private async formatConfigLocations(data: any): Promise<any> {
    const formConfigLocations = data;
    let formatConfigLocationsData = {};
    for (const [key, item] of Object.entries(formConfigLocations)) {
      const val: any = item;
      formatConfigLocationsData = {...formatConfigLocationsData, [key]: (val || {}).value}
    }
    return formatConfigLocationsData;
  }

  private getLocationName(id: string): string {
    const locationData = this.locations.items && this.locations.items.find((loc: any) => loc.id === parseInt(id));
    if (locationData) {
      return locationData.name;
    }

    return "";
  }

  private async unTickIsCustomised(): Promise<any> {
    const configLocations = this.form.config.locations;
    const configLocationsLength = configLocations ? Object.values(configLocations).length : 0;
    let emptyValueCount = 0;
    for (const [key, item] of Object.entries(configLocations)) {
      const val: any = item;
      if (!val.value) {
        emptyValueCount += 1;
      }
    }

    if (configLocationsLength === emptyValueCount) {
      this.isCustomised = false;
    }
  }

  private async created (): Promise<void> {
    console.log({
      form: this.form,
      data: this.data
    })
    await this.$store.dispatch('visitManagement/fetchLocations', {
      editable: true,
      archived: false,
    });
    await this.getFormContactLocations();
    await this.unTickIsCustomised();
  }
}
